import { Coffee } from 'lucide-react'
import { Banner } from '../ui/banner'

export default function TransferringDisclaimer() {
  return (
    <Banner
      variant='informative'
      className='py-4 gap-4 animate-fade-in'
      description='Keep Polaris open in your browser while your trade is in progress.'
      icon={
        <Coffee
          width={24}
          height={24}
          className='text-orange-500 relative top-1.5 min-w-6'
        />
      }
    />
  )
}
